import { useData } from "../../context/DataContext";
import { Card, CardHead, Btn, TableWrap, Th, Td, Pill, EmptyState } from "../kit";
import { fmtINR, clientTotals, clientsWhatsApp } from "../../lib/finance";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export default function Clients({ goClient }) {
  const { clients } = useData();
  const rows = clients.slice().sort((a, b) => a.name.localeCompare(b.name));

  const copy = () => {
    navigator.clipboard.writeText(clientsWhatsApp(clients))
      .then(() => toast.success("Copied — paste straight into WhatsApp"))
      .catch(() => toast.error("Could not copy"));
  };

  return (
    <Card>
      <CardHead title="Clients" subtitle={`${rows.length} clients`} right={
        <Btn variant="outline" onClick={copy} data-testid="whatsapp-summary-copy-button"><Copy className="h-4 w-4" /> WhatsApp summary</Btn>
      } />
      <div className="mt-4">
        {rows.length === 0 ? <EmptyState>No clients yet. Add one from the "Add Entry" tab.</EmptyState> : (
          <TableWrap>
            <thead><tr><Th>Name</Th><Th className="text-right">Total Paid</Th><Th className="text-right">Balance</Th><Th>Last Payment</Th></tr></thead>
            <tbody>
              {rows.map((c) => {
                const { paid, lastDate } = clientTotals(c);
                return (
                  <tr key={c.id} className="hover:bg-slate-50">
                    <Td><button onClick={() => goClient(c.id)} className="font-semibold text-primary hover:underline text-left">{c.name}</button></Td>
                    <Td className="text-right tnum text-emerald-600 font-semibold">{fmtINR(paid)}</Td>
                    <Td className="text-right tnum">{c.balance > 0 ? <Pill tone="expense">{fmtINR(c.balance)}</Pill> : <Pill tone="income">Cleared</Pill>}</Td>
                    <Td className="text-slate-500">{lastDate}</Td>
                  </tr>
                );
              })}
            </tbody>
          </TableWrap>
        )}
      </div>
      <div className="h-4" />
    </Card>
  );
}
